import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { PushDevice } from '@nucleus-commerce/api-client/admin';

import { pushApi } from '../api/push-api';
import { currentSubscription } from '../lib/push-browser';

import { pushKeys } from './push-keys';

/** Deletes this browser's row first, so a failure leaves it subscribed and still listed. */
export function useDisablePush(publicKey: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (device: PushDevice | null) => {
      if (device) await pushApi.remove(device.id);
      const subscription = await currentSubscription();
      if (subscription) await subscription.unsubscribe();
    },
    meta: { successMessage: 'push:toasts.disabled' },
    onSuccess: () => {
      queryClient.setQueryData(pushKeys.thisDevice(publicKey), null);
      void queryClient.invalidateQueries({ queryKey: pushKeys.settings() });
    },
  });
}
